const generateTwitterLink = (holeNumber, url) => {
  const formattedUrl = `${url}?hole=${holeNumber}`;
  const tweetText = `Find out how pros will approach Hole ${holeNumber} of The Country Club in Brookline with our 2022 US Open course map. — The Boston Globe`;
  const params = [
    `text=${encodeURI(tweetText)}`,
    `url=${encodeURI(formattedUrl)}`,
    'via=BostonGlobe',
  ];
  return `https://twitter.com/intent/tweet?${params.join('&')}`;
};

export default generateTwitterLink;
